module.exports = __webpack_public_path__ + "mc.svg?04a4a202a022ccc10add49ca6cf706fd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mc.svg
// module id = 1485
// module chunks = 0